import { observable } from "mobx";
/**
* RacingTrackInfo defines additional information from the feed for the event
*
* @typedef RacingTrackInfo
* @type {Object}
* @property {eventId} Unique identifier
* @property {going} current line odds
* @property {diomedVerdict} commentary for the event provided by the feed
*/

export class RacingTrackInfo {
    eventId: string;
    going?: string;
    @observable diomedVerdict?: string;

    constructor(source: RacingTrackInfo) {
        this.eventId = source.eventId;
        this.going = source.going;
        this.diomedVerdict = source.diomedVerdict;
    }

}